import {
  AdminSelect,
  ANNOUNCEMENT_APPS,
  ANNOUNCEMENT_PLATFORMS,
  AnnouncementApp,
  AnnouncementPlatform,
  Div,
} from '@vgrubs/components';
import type { AnnouncementFilters as Filters } from '../hooks/useAnnouncementsList';

type Props = {
  filters: Filters;
  onChange: <Key extends keyof Filters>(key: Key, value: Filters[Key]) => void;
};

/**
 * The three dropdowns, laid out the way every other admin list lays its
 * filters out: one row of equal thirds that stacks on a phone. The search sits
 * in the header rather than here, so it is in the same place on every page.
 */
export const AnnouncementFilters = ({ filters, onChange }: Props) => (
  <Div
    $flex
    $between
    $alignCenter
    $columnSM
    $gap="32px"
    $gapSM="8px"
    $m="32px 0"
    $mSM="12px 0 20px 0"
  >
    <Div $width="33%" $widthSM="100%">
      <AdminSelect
        value={filters.app}
        onChange={(e) =>
          onChange('app', e.target.value as AnnouncementApp | '')
        }
        options={
          <>
            <option value="">All apps</option>
            {ANNOUNCEMENT_APPS.map((app) => (
              <option key={app} value={app}>
                {app}
              </option>
            ))}
          </>
        }
        $shadowDesign
      />
    </Div>

    <Div $width="33%" $widthSM="100%">
      <AdminSelect
        value={filters.platform}
        onChange={(e) =>
          onChange('platform', e.target.value as AnnouncementPlatform | '')
        }
        options={
          <>
            <option value="">All platforms</option>
            {ANNOUNCEMENT_PLATFORMS.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </>
        }
        $shadowDesign
      />
    </Div>

    <Div $width="33%" $widthSM="100%">
      <AdminSelect
        value={filters.active}
        onChange={(e) =>
          onChange('active', e.target.value as Filters['active'])
        }
        options={
          <>
            <option value="">All statuses</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </>
        }
        $shadowDesign
      />
    </Div>
  </Div>
);
